export interface PagePratica {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  content?: PraticaUtente[];
  number?: number;
  numberOfElements?: number;
  last?: boolean;
  first?: boolean;
  empty?: boolean;
}

export interface NotaPratica {
  nota?: string;
  operatore?: string;
  dataOperazione?: number;
}

export interface AggiornamentoPratica {
  operazioni?: string[];
  dataOperazione?: number;
}

export interface PraticaUtente {
  slugComune?: string;
  codicePratica?: string;
  counter?: number;
  codiceTipoPratica?: string;
  anagrafica?: PraticaAnagrafica;
  elementiNucleoFamiliare?: ElementoNucleoFamiliare[];
  statusRichiesta?: RichiestaPraticaStatusBE;
  statusGraduatoria?: string;
  timestampRichiesta?: string;
  timestampConfermaPratica?: string;
  punteggioPratica?: number;
  valoreBonusRiconosciuto?: number;
  lockStatus?: boolean;
  origineRichiesta?: string;
  note?: NotaPratica[];
  aggiornamenti?: AggiornamentoPratica[];
  created_at?: string;
  updated_at?: string;
}

export interface ElementoNucleoFamiliare {
  id?: string;
  nome?: string;
  cognome?: string;
  codiceFiscale?: string;
  parentela?: string;
  dataNascita?: number;
  text1_1?: string;
  text1_2?: string;
}

export interface PraticaAnagrafica {
  id?: string;
  nome?: string;
  cognome?: string;
  codiceFiscale?: string;
  email?: string;
  cellulare?: string;
}

export enum RichiestaPraticaStatusBE {
  IN_ATTESA_REVIEW_PDF = 'IN_ATTESA_REVIEW_PDF',
  IN_ATTESA_OTP = 'IN_ATTESA_OTP',
  IN_ATTESA_FIRMA = 'IN_ATTESA_FIRMA',
  IN_ATTESA_DOCUMENTO = 'IN_ATTESA_DOCUMENTO',
  RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
  RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
  RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
  RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
  VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
  VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI',
}
